<template v-if="globaljs.mb_staff !== 'Worker'">
	<include-header />

	<section id="lab_charge_partner">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont sub_cont1">
					<div class="boardTit">거래처 정산</div>
					<div class="searchBox">
						<form ref="form_search" id="form_search" @submit.prevent="getModels()">
							<div class="searchRow">
								<div class="searchCont">
									<label for="dentalPartnerSearch" class="form-label required">{{ other_type
										}}명</label>
									<input type="text" class="form-control" v-model="searchModels.partner"
										id="dentalPartnerSearch" :placeholder="`${other_type}명`">
								</div>
								<div class="searchCont">
									<label for="chargeMonthSearch" class="form-label required">청구 월</label>
									<input type="month" class="form-control" id="chargeMonthSearch"
										v-model="searchModels.chargeMonthSearch" pattern="[0-9]{4}-[0-9]{2}">
									<span class="hyphen">-</span>
									<input type="month" class="form-control" id="chargeMonthSearch2"
										v-model="searchModels.chargeMonthSearch2" pattern="[0-9]{4}-[0-9]{2}">
								</div>
								<div>
									<button type="button" class="search_btn" id="searchBtn" @click.prevent="getModels()">검색</button>
									<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="searchReset()">초기화</button>
								</div>
							</div>
						</form>
					</div>
					<div class="sub_contBox">
						<form ref="form_pay_update" id="form_pay_update" :action="`${SERVER_URL}/api/app/bill/pay`"
							@submit.prevent="form_pay_update_submit()" method="post" autocomplete="off">
							<div class="subTitWrap">
								<div class="subTit">[거래처 정산 목록]</div>
								<ul v-if="globaljs.acc_type === 'lab'" class="subBtn">
									<li v-show="view_mode"><button type="button" id="cEditBtn"
											@click="editMode()">수정</button></li>
									<li v-show="!view_mode"><button type="button" id="cEditBtn"
											@click="viewMode()">취소</button></li>
									<li v-show="!view_mode"><button type="button" id="cSaveBtn"
											@click="form_pay_update_submit()">저장</button></li>
								</ul>
							</div>
							<table>
								<thead>
									<tr>
										<th class="chargeCols1">청구 월</th>
										<th class="chargeCols2">{{ other_type }}</th>
										<th class="chargeCols3">치식 수량</th>
										<th class="chargeCols4">당월 청구금액</th>
										<th class="chargeCols6">가격 조정금액</th>
										<th class="chargeCols7">최종 청구금액</th>
										<th class="chargeCols5">미수금액</th>
										<th class="chargeCols8">당월 결제금액</th>
									</tr>
								</thead>
								<tbody v-if="items.length > 0">
									<template v-for="(item, index) in items" :key="index">
										<tr v-for="(sub, idx) in item.bill_sub" :key="idx">
											<input type="hidden" name="bill_sub_id[]" :value="sub.id">
											<td class="chargeCols1">
												<input type="hidden" name="hospital_mb_id[]" :value="item?.bills?.hospital_mb_id">
												<input type="hidden" name="charge_month[]" :value="item?.month">
												{{ item?.month }}
												<div v-if="clientIP === '182.219.119.124'"><span class="text-orange">* [위트리IP에서만 보임]</span> ID: {{sub.id}}
													 <!-- / 최초발행일 <span class="text-blue">{{ commonjs.dateFormatYMDHis(sub?.firstbill_datetime) }}</span> -->
												</div>
											</td>
											<td class="chargeCols2">{{ globaljs.acc_type === 'lab' ? item?.bills?.memberBill_Hospital?.mb_nick : item?.bills?.memberBill_Lab?.mb_nick }}</td>
											<td class="chargeCols3">{{ teeth_count(index, sub) }}</td>
											<td class="chargeCols4">{{ total_price_all(index, sub).toLocaleString() }}
											</td>
											<td class="chargeCols5">{{ total_discount(index, sub).toLocaleString() }}
											</td>
											<td class="chargeCols6">{{ total_price(index, sub).toLocaleString() }}</td>
											<td class="chargeCols7">{{ not_paid(item, sub, idx).toLocaleString() }}</td>
											<td class="chargeCols8">
												<input type="text" data-type="number" name="charge_paid[]" :value="charge_paid(item, idx)" @input="commonjs.maxLengthCheck($event)" @blur="commonjs.valueCheck($event)">
											</td>
										</tr>
									</template>
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="8">데이터가 없습니다.</td>
									</tr>
								</tbody>
							</table>
						</form>

						<!-- <div class="page">
							<ul :id="HZpaginationId" class="pagination">
								<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
								<li>
									<ul class="num_wrap">
										<li v-for="page in pagesToShow" :key="page"
											:class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']"
											@click="goToPage(page)">
											{{ page }}
										</li>
									</ul>
								</li>
								<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
							</ul>
						</div> -->

						<hr>

						<form id="data_chargeTotalForm" name="frmChargeTotal">
							<div class="subTitWrap">
								<div class="subTit">[총 합계]</div>
							</div>
							<table>
								<tbody>
									<tr>
										<th class="chargeCols1"></th>
										<th class="chargeCols3">치식 수량</th>
										<th class="chargeCols4">당월 청구금액</th>
										<th class="chargeCols5">가격 조정금액</th>
										<th class="chargeCols6">최종 청구금액</th>
										<th class="chargeCols7">미수금액</th>
										<th class="chargeCols8">당월 결제금액</th>
									</tr>
									<tr>
										<td class="chargeCols1">합계</td>
										<td class="chargeCols3">{{ all_teeth_count }}</td>
										<td class="chargeCols4">{{ all_total_price_all.toLocaleString() }}</td>
										<td class="chargeCols5">{{ all_total_discount > 0 ? all_total_discount.toLocaleString() : 0 }}</td>
										<td class="chargeCols6">{{ all_total_price.toLocaleString() }}</td>
										<td class="chargeCols7">{{ (all_total_price - all_charge_paid).toLocaleString()
											}}
										</td>
										<td class="chargeCols8">{{ all_charge_paid.toLocaleString() }}</td>
									</tr>
								</tbody>
							</table>
						</form>
					</div>
				</div>
			</div>
		</div>

	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

if(globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

const clientIP = ref(null);

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

let form_search = ref(null)
let searchModels = ref({
	chargeMonthSearch: moment().add(-5, 'months').format('YYYY-MM'),
	chargeMonthSearch2: moment().format('YYYY-MM'),
})

const items = ref([]);
const billJsonData = ref([]);

onMounted(async () => {
	if(globaljs.mb_staff !== 'Worker') { 
		clientIP.value = await commonjs.getIpAddress();

		await getModels();
	}
});

// 초기화 함수
const searchReset = async () => {
	searchModels.value = Object.assign({});
	form_search.value.reset();
	document.querySelectorAll('form#form_search select').forEach(function (selectElement) {
		selectElement.value = '';
		selectElement.selected = true;
	});
	searchModels.value.chargeMonthSearch = moment().add(-5, 'months').format('YYYY-MM');
	searchModels.value.chargeMonthSearch2 = moment().format('YYYY-MM');

	// 합계 관련 변수 초기화
	all_teeth_count.value = 0;
	all_total_price_all.value = 0;
	all_total_discount.value = 0;
	all_total_price.value = 0;
	all_charge_paid.value = 0;

	await getModels();
};

// 하나라도 검색 조건이 지정되어 있는지 확인
const isSearchActive = computed(() => {
	console.log('isSearchActive');
	return true;
	//return Object.values(searchModels.value).some(value => value !== '');
});

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 10;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

let all_teeth_count = ref(0);
	const teeth_count = (index, sub) => {
		let cnt = 0;
		let bill_json = JSON.parse(sub.bill_json_data);

		if (typeof bill_json.teeths === 'string') {
			cnt = bill_json.teeths.split('/').length;
		} else {
			for (let k = 0; k < bill_json?.teeths?.length; k++) {
				let teethArr = bill_json.teeths[k].split('/');
				cnt += teethArr.length;
			}
		}
		return cnt;
	}
	const calc_all_teeth_count = () => {
		let totalCount = 0;
		//paginatedItems.value.forEach(item => {
		items.value.forEach(item => {
			item.bill_sub.forEach(sub => {
				let cnt = 0;
				let bill_json = JSON.parse(sub.bill_json_data);

				if (typeof bill_json.teeths === 'string') {
					cnt = bill_json.teeths.split('/').length;
				} else {
					for (let k = 0; k < bill_json?.teeths?.length; k++) {
						let teethArr = bill_json.teeths[k].split('/');
						cnt += teethArr.length;
					}
				}
				totalCount += cnt;
			});
		});
		all_teeth_count.value = totalCount;
	};

let all_total_price_all = ref(0);
	const total_price_all = (index, sub) => {
		let price = 0;
		let bill_json = JSON.parse(sub.bill_json_data);

		if (typeof bill_json.price_sum === 'string') {
			price = parseInt(bill_json?.price_sum|| 0, 10);
		} else {
			for (let k = 0; k < bill_json?.price_sum?.length; k++) {
				price += parseInt(bill_json?.price_sum[k]|| 0, 10);
			}
		}
		return price;
	}
	const calc_all_total_price_all = () => {
		let totalPrice = 0;
		items.value.forEach(item => {
			item.bill_sub.forEach(sub => {
				let price = 0;
				let bill_json = JSON.parse(sub.bill_json_data);

				if (typeof bill_json.price_sum === 'string') {
					price = parseInt(bill_json.price_sum|| 0, 10);
				} else {
					for (let k = 0; k < bill_json.price_sum.length; k++) {
						price += parseInt(bill_json.price_sum[k]|| 0, 10);
					}
				}
				totalPrice += price;
			});
		});
		all_total_price_all.value = totalPrice;
	};

let all_total_discount = ref(0);
	const total_discount = (index, sub) => {
		let discount = 0;
		let bill_json = JSON.parse(sub.bill_json_data);

		discount += parseInt(bill_json?.chargeAdjust|| 0, 10);
		//all_total_discount += discount;
		return discount;
	}
	const calc_all_total_discount = () => {
		let totalDiscount = 0;
		items.value.forEach(item => {
			item.bill_sub.forEach(sub => {
				let discount = 0;
				let bill_json = JSON.parse(sub.bill_json_data);

				discount += parseInt(bill_json?.chargeAdjust, 10) || 0;
				totalDiscount += discount;
			});
		});
		all_total_discount.value = totalDiscount;
	};

let all_total_price = ref(0);
	const total_price = (index, sub) => {
		let price = 0;
		let bill_json = JSON.parse(sub.bill_json_data);

		if (typeof bill_json.price_sum === 'string') {
			price = parseInt(bill_json?.price_sum|| 0, 10);
		} else {
			for (let k = 0; k < bill_json?.price_sum?.length; k++) {
				price += parseInt(bill_json?.price_sum[k]|| 0, 10);
			}
		}
		price -= parseInt(bill_json?.chargeAdjust|| 0, 10);
		return price;
	}
	const calc_all_total_price = () => {
		let totalPrice = 0;
		items.value.forEach(item => {
			item.bill_sub.forEach(sub => {
				let price = 0;
				let bill_json = JSON.parse(sub.bill_json_data);

				if (typeof bill_json.price_sum === 'string') {
					price = parseInt(bill_json?.price_sum|| 0, 10);
				} else {
					for (let k = 0; k < bill_json?.price_sum?.length; k++) {
						price += parseInt(bill_json.price_sum[k]|| 0, 10);
					}
				}
				price -= parseInt(bill_json?.chargeAdjust, 10) || 0;
				totalPrice += price;
			});
		});
		all_total_price.value = totalPrice;
	};

let all_charge_paid = ref(0);
	const charge_paid = (item, idx) => {
		let paid = 0;
		//let bill_json = JSON.parse(sub.bill_json_data);
		paid = item?.pay?.[idx].charge_paid || 0;
		//all_charge_paid += paid;
		return paid;
	}
	const calc_all_charge_paid = () => {
		let totalPaid = 0;
		items.value.forEach(item => {
			item?.pay?.forEach(sub => {
				let paid = sub?.charge_paid || 0;
				totalPaid += paid;
			})
		});
		all_charge_paid.value = totalPaid;
	};

const not_paid = (item, sub, idx) => {
	let price = 0;
	let bill_json = JSON.parse(sub.bill_json_data);

	if (typeof bill_json.price_sum === 'string') {
		price = parseInt(bill_json?.price_sum|| 0, 10);
	} else {
		for (let k = 0; k < bill_json?.price_sum?.length; k++) {
			price += parseInt(bill_json?.price_sum[k]|| 0, 10);
		}
	}
	price -= parseInt(bill_json?.chargeAdjust|| 0, 10);

	let paid = 0;
	paid = item?.pay?.[idx].charge_paid || 0;
	//paid = item?.pay?.charge_paid || 0;

	return price - paid;
}

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	params.append('mb_boss_id', globaljs.mb_boss_id);

	if (searchModels.value != undefined) {
		Object.keys(searchModels.value).map(v => {
			params.append(v, searchModels.value[v]);
		});
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/bill/pay`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
		currentPage.value = 1; // 240822 1페이지로 고정

		calc_all_teeth_count();
		calc_all_total_price_all();
		calc_all_total_discount();
		calc_all_total_price();
		calc_all_charge_paid();

	} catch (error) {
console.error('Error getModels:', error);
	}
}

const view_mode = ref(true);

const editMode = () => {
	if (globaljs.acc_type === 'lab') {
		document.getElementById('form_pay_update').classList.add('editable');
		document.querySelectorAll("input[name='charge_paid[]']").forEach(input => {
			input.value = parseInt(input.value.replace(",", ""));
			//input.setAttribute('type', 'number');
			input.focus();
		});
		view_mode.value = !view_mode.value;
	}
}

const viewMode = () => {
	if (globaljs.acc_type === 'lab') {
		document.getElementById('form_pay_update').classList.remove('editable');
		document.querySelectorAll("input[name='charge_paid[]']").forEach(input => {
			input.value = parseInt(input.value).toLocaleString();
			//input.setAttribute('type', 'text');
			input.blur();
		});
		view_mode.value = !view_mode.value;
	}
}

async function form_pay_update_submit() {
	await withSubmitFlag(async () => {
		if (globaljs.acc_type === 'lab') {
			if (!view_mode.value) {
				const chargePartnerForm = document.getElementById('form_pay_update');
				chargePartnerForm.classList.remove('editable');

				const params = new URLSearchParams();
				params.append('acc_type', globaljs.acc_type);
				//params.append('mb_level', globaljs.mb_level);
				params.append('mb_boss_id', globaljs.mb_boss_id);

				const formElement = document.getElementById('form_pay_update');
				const essentials = formElement.querySelectorAll('[required]');
				for (const element of essentials) {
					if (!element.value || element.value.trim() === '' || element.value.trim().length < 1) {
						const label = formElement.querySelector(`label[for="${element.id}"]`);
						const fieldName = label ? label.textContent.replace(':', '') : element.name;
						commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
						return false;
					}

					// input type="date"의 경우 날짜 형식 검증
					if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
						const label = formElement.querySelector(`label[for="${element.id}"]`);
						const fieldName = label ? label.textContent.replace(':', '') : element.name;
						commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
						return false;
					}
				}

				formElement.querySelectorAll('input').forEach((input) => {
					if (input.type === 'checkbox' && input.id !== 'chk_all' && input.name !== "") {
						if (input.checked) {
							if (!params.has(input.name)) {
								params.append(input.name, input.value);
							} else {
								const existingValue = params.get(input.name);
								params.set(input.name, `${existingValue},${input.value}`);
							}
						}
					} else if (input.type === 'radio' && input.name !== "") {
						if (input.checked) {
							params.append(input.name, input.value);
						}
					} else if (input.name) { // input.name이 존재하는 경우에만 추가
						params.append(input.name, input.value);
					}
				});

				formElement.querySelectorAll('select').forEach((select) => {
					if (select.name) { // select.name이 존재하는 경우에만 추가
						params.append(select.name, select.value);
					}
				});

				formElement.querySelectorAll('textarea').forEach((textarea) => {
					if (textarea.name) { // textarea.name이 존재하는 경우에만 추가
						params.append(textarea.name, textarea.value);
					}
				});

				// URLSearchParams를 객체로 변환
				const object = {};
				params.forEach((value, key) => {
					if (key.endsWith('[]')) {
						const arrayKey = key.slice(0, -2);
						if (!object[arrayKey]) {
							object[arrayKey] = [];
						}
						object[arrayKey].push(value);
					} else {
						object[key] = value;
					}
				});

				// 결과 확인용 로그 출력
				const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

				try {
					const response = await axios.put(`${SERVER_URL}/api/app/bill/pay`, params);
	console.debug(response.data.result);
					toast.fire({
						icon: "success",
						title: "결제금액을 수정했습니다."
					});

					getModels();
					viewMode(); // 240827 보기모드로 변경

				} catch (error) {
					console.error(error?.response?.data);
					commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
				}
			}
		}
	});
}
</script>